import { CreditcardPipe } from './creditcard.pipe';
import { PhonePipe } from './phone.pipe';
import { DynamicPipe } from './dynamic-pipe.pipe';
import { IbanPipe } from './iban.pipe';
import { LocalCurrencyPipe } from './localized/local-currency.pipe';
import { LocalDatePipe } from './localized/local-date.pipe';
import { LocalNumberPipe } from './localized/local-number.pipe';
import { TitleCasePipe } from './localized/title-case.pipe';
import { KeepDecimalPipe } from './localized/keep-decimal.pipe';
import { SearchPipe } from './seach.pipe';
import { ResourceDisplayPipe } from './resource.display.pipe';
import { LocalDateTimePipe } from './local-date-time.pipe';
import { LocalCurrencyFormatterPipe } from './localized/local-currency-formatter.pipe';

export {
    CreditcardPipe,
    PhonePipe,
    DynamicPipe,
    IbanPipe,
    LocalCurrencyPipe,
    LocalDatePipe,
    LocalNumberPipe,
    TitleCasePipe,
    KeepDecimalPipe,
    SearchPipe,
    ResourceDisplayPipe,
    LocalDateTimePipe,
    LocalCurrencyFormatterPipe
}

export const Gsp_pipes = [
    CreditcardPipe,
    PhonePipe,
    DynamicPipe,
    IbanPipe,
    LocalCurrencyPipe,
    LocalDatePipe,
    LocalNumberPipe,
    TitleCasePipe,
    KeepDecimalPipe,
    SearchPipe,
    ResourceDisplayPipe,
    LocalDateTimePipe,
    LocalCurrencyFormatterPipe
]